import React, { useMemo } from 'react';
import { RawTrader, TraderCardData } from './types';
import { RAW_TRADERS } from './mockData';
import  ExpertHeroSlider  from './ExpertHeroSlider';
import { ExpertFilterBar } from './ExpertFilterBar';
import { ExpertTraderSection } from './ExpertTraderSection';

interface DirectoryViewProps {
  size: string;
  onSizeChange: (val: string) => void;
  q: string;
  onQChange: (val: string) => void;
  platform: string;
  onPlatformChange: (val: string) => void;
  stage?: string;
  onStageChange?: (val: string) => void;
  sort: string;
  onSortChange: (val: string) => void;
  layout: 'list' | 'grid';
  onLayoutChange: (val: 'list' | 'grid') => void;
  cards: TraderCardData[];
  podium: TraderCardData[];
  rest: TraderCardData[];
  totalFilteredCount: number;
  onSelectTrader: (rawIndex: number) => void;
  onResetFilters: () => void;
}

export const DirectoryView: React.FC<DirectoryViewProps> = ({
  q,
  onQChange,
  platform,
  onPlatformChange,
  cards,
  onSelectTrader,
  onResetFilters,
}) => {
  const activeTraders = useMemo(() => {
    return cards.map((c) => ({
      t: RAW_TRADERS[c.rawIndex],
      card: c,
    }));
  }, [cards]);

  const mt4List = useMemo(() => {
    return activeTraders.filter(({ t }) => t.platform.toLowerCase() === 'mt4');
  }, [activeTraders]);

  const mt5List = useMemo(() => {
    return activeTraders.filter(({ t }) => t.platform.toLowerCase() === 'mt5');
  }, [activeTraders]);

  const ctraderList = useMemo(() => {
    return activeTraders.filter(({ t }) => t.platform.toLowerCase() === 'ctrader');
  }, [activeTraders]);

  const currentPlatformLower = platform.toLowerCase();

  return (
    <div className="min-h-screen text-gray-900 pb-12">
      <div className="max-w-7xl mx-auto py-2">
        {/* Top Hero Banner Carousel */}
        <ExpertHeroSlider />

        {/* Search & Platform Filter Bar */}
        <ExpertFilterBar
          searchQuery={q}
          onSearchChange={onQChange}
          selectedPlatform={platform}
          onSelectPlatform={onPlatformChange}
        />

        {/* Section: MT4 */}
        {(currentPlatformLower === 'all' || currentPlatformLower === 'mt4') && (
          <ExpertTraderSection
            title="Chiến Lược & Quản Lý Quỹ MT4 Hàng Đầu"
            description="Các chuyên gia sử dụng nền tảng MetaTrader 4 có hiệu suất tốt nhất."
            buttonLabel="Xem Tất Cả MT4"
            traders={mt4List}
            onSelectTrader={onSelectTrader}
            onViewAll={currentPlatformLower === 'all' ? () => onPlatformChange('mt4') : undefined}
          />
        )}

        {/* Section: MT5 */}
        {(currentPlatformLower === 'all' || currentPlatformLower === 'mt5') && (
          <ExpertTraderSection
            title="Chiến Lược & Tài Khoản MT5 Nổi Bật"
            description="Được thiết kế cho sức mạnh của MetaTrader 5 với các chỉ số và dữ liệu nâng cao."
            buttonLabel="Xem Tất Cả MT5"
            traders={mt5List}
            onSelectTrader={onSelectTrader}
            onViewAll={currentPlatformLower === 'all' ? () => onPlatformChange('mt5') : undefined}
          />
        )}

        {/* Section: cTrader */}
        {(currentPlatformLower === 'all' || currentPlatformLower === 'ctrader') && (
          <ExpertTraderSection
            title="Chuyên Gia Giao Dịch cTrader"
            description="Lợi nhuận được tối ưu qua thuật toán trên nền tảng cTrader hiện đại và mượt mà."
            buttonLabel="Xem Tất Cả cTrader"
            traders={ctraderList}
            onSelectTrader={onSelectTrader}
            onViewAll={currentPlatformLower === 'all' ? () => onPlatformChange('ctrader') : undefined}
          />
        )}

        {/* Empty state */}
        {cards.length === 0 && (
          <div className="bg-white !rounded-xl p-12 text-center border border-gray-200">
            <div className="text-base font-bold text-gray-900 mb-2">Không tìm thấy trader nào phù hợp</div>
            <p className="text-sm text-gray-500 mb-4">
              Vui lòng thử tìm kiếm bằng từ khoá khác hoặc chọn lại bộ lọc Nền tảng.
            </p>
            <button
              onClick={onResetFilters}
              className="px-4 py-2 bg-blue-600 text-white !rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors cursor-pointer border-0"
            >
              Xoá bộ lọc
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
